export function namePattern() {
    const allowedRanges = [
        'a-z',
        'A-Z',
        '\u00C0-\u00D6',
        '\u00D8-\u00F6',
        '\u00F8-\u00FF',
        '\'',
    ].join('');

    return `^[${allowedRanges}]+(([',. -][${allowedRanges} ])?[${allowedRanges}]*)*$`;
}

export function entityNamePattern() {
    const allowedRanges = [
        'a-z',
        'A-Z',
        '0-9',
        '\u00C0-\u00D6',
        '\u00D8-\u00F6',
        '\u00F8-\u00FF',
        '\'',
        '\\.',
        '\\-',
    ].join('');

    return `^[${allowedRanges}]+(([',. -][${allowedRanges} ])?[${allowedRanges}]*)*$`;
}

// Same as streetName
export function cityNamePattern() {
    const allowedRanges = [
        'a-z',
        'A-Z',
        '0-9',
        '\u00C0-\u00D6',
        '\u00D8-\u00F6',
        '\u00F8-\u00FF',
        '\'',
        '\\.',
        '\\-',
    ].join('');

    return `^[${allowedRanges}]+(([',. -][${allowedRanges} ])?[${allowedRanges}]*)*$`;
}

// Same as cityName
export function streetNamePattern() {
    const allowedRanges = [
        'a-z',
        'A-Z',
        '0-9',
        '\u00C0-\u00D6',
        '\u00D8-\u00F6',
        '\u00F8-\u00FF',
        '\'',
        '\\.',
        '\\-',
    ].join('');

    return `^[${allowedRanges}]+(([',. -][${allowedRanges} ])?[${allowedRanges}]*)*$`;
}

export function initialsPattern() {
    const allowedRanges = [
        'a-z',
        'A-Z',
        '\u00C0-\u00D6',
        '\u00D8-\u00F6',
        '\u00F8-\u00FF',
        '.',
    ].join('');

    return `^[${allowedRanges}]+$`;
}

export function emailPattern() {
    // eslint-disable-next-line max-len
    return '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';
}

// This is a very incmplete regex
export function phoneNumberPattern() {
    return '[0-9\\- \\+\\(\\)]{10,}';
}

export function datePattern() {
    return '^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$';
}

// Validates date in format 'dd-MM-yyyy'
export function localeDatePattern() {
    return '^(\\d{1,2})-(\\d{1,2})-(\\d{4,4})$';
}

export function ibanPattern() {
    // eslint-disable-next-line max-len
    return '^(?:(?:IT|SM)\\d{2}[A-Z]\\d{22}|CY\\d{2}[A-Z]\\d{23}|NL\\d{2}[A-Z]{4}\\d{10}|LV\\d{2}[A-Z]{4}\\d{13}|(?:BG|BH|GB|IE)\\d{2}[A-Z]{4}\\d{14}|GI\\d{2}[A-Z]{4}\\d{15}|RO\\d{2}[A-Z]{4}\\d{16}|KW\\d{2}[A-Z]{4}\\d{22}|MT\\d{2}[A-Z]{4}\\d{23}|NO\\d{13}|(?:DK|FI|GL|FO)\\d{16}|MK\\d{17}|(?:AT|EE|KZ|LU|XK)\\d{18}|(?:BA|HR|LI|CH|CR)\\d{19}|(?:GE|DE|LT|ME|RS)\\d{20}|IL\\d{21}|(?:AD|CZ|ES|MD|SA)\\d{22}|PT\\d{23}|(?:BE|IS)\\d{24}|(?:FR|MR|MC)\\d{25}|(?:AL|DO|LB|PL)\\d{26}|(?:AZ|HU)\\d{27}|(?:GR|MU)\\d{28})$';
}

export function genderPattern() {
    return '^[MFX]{1}$';
}

export function postalCodePattern() {
    return '^([0-9]{4}[ ]?[A-Za-z]{2})$';
}

export function houseNumberPattern() {
    return '^[0-9\\-]+$';
}

export function houseNumberExtensionPattern() {
    return '^[0-9a-zA-Z\\- ]+$';
}

export function passwordPattern() {
    return '^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,}$';
}
